import { render, staticRenderFns } from "./UpdateUserRolesModal.vue?vue&type=template&id=5d991b59&scoped=true&"
import script from "./UpdateUserRolesModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserRolesModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserRolesModal.vue?vue&type=style&index=0&id=5d991b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d991b59",
  null
  
)

export default component.exports